<template>
  <input type="text" ref="input" id="pac-input"
            placeholder="장소명이나 주소">
</template>

<script>
export default {
  props: {
    google: Object,
    map: Object
  },
  data () {
    return {
      autocomplete: null
    }
  },
  mounted () {
    this.drawControl()
  },
  methods: {
    drawControl () {
      const input = this.$refs.input
      const options = {
        componentRestrictions: { country: 'kr' }
      }
      this.autocomplete = new this.google.maps.places.Autocomplete(input, options)

      this.autocomplete.bindTo('bounds', this.map)

      this.autocomplete.addListener('place_changed', () => {
        const place = this.autocomplete.getPlace()

        if (!place.geometry) {
          alert(`No details available for input: ${place.name}`)
          return
        }

        const location = place.geometry.location

        if (place.geometry.viewport) {
          this.map.fitBounds(place.geometry.viewport)
        } else {
          this.map.setCenter(location)
          this.map.setZoom(17)
        }

        const address = place.formatted_address

        this.$emit('change', { location, address })
      })
    }
  }
}
</script>

<style scoped>
#pac-input {
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin-left: 12px;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 400px;
}

#pac-input:focus {
  border-color: #4d90fe;
}
</style>
